import { render, staticRenderFns } from "./MixProdutosVendidos.vue?vue&type=template&id=5dbd3c50&"
import script from "./MixProdutosVendidos.vue?vue&type=script&lang=js&"
export * from "./MixProdutosVendidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/taylor-minhasvendas-frontend-teste/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dbd3c50')) {
      api.createRecord('5dbd3c50', component.options)
    } else {
      api.reload('5dbd3c50', component.options)
    }
    module.hot.accept("./MixProdutosVendidos.vue?vue&type=template&id=5dbd3c50&", function () {
      api.rerender('5dbd3c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/MixProdutosVendidos.vue"
export default component.exports